import {Button, DialogActions, DialogTitle} from "@mui/material";
import {Dialog2} from "../../../misc/Dialog2";
import {PopperZIndexProvider} from "../../../misc/scroller/PopperZIndexProvider";
import useWindowSize from "react-use/lib/useWindowSize";
import {SelectCol, StringCol, Table} from "../../../misc/scroller/Table";
import {getAll} from "../../logistics/routes/useGetAll";
import {api} from "../../../api/API";
import {Tag} from "../../../api/Tasks2";
import {removeRowOption, RowOptionCol} from "../../logistics/purchasing/RowOptions";
import {ReceivableItem} from "../../../api/Receivables";
import {AutoInsert} from "../../project/shopdrawing/openings/AutoInsertOpening";
import {blue, brown, green, grey, orange, pink, purple, red, yellow} from "@mui/material/colors";
import {TagItem} from "./TagItem";

const tableName = "tag.manager";

const colors = [
    blue["600"],
    green["600"],
    red["600"],
    orange["600"],
    yellow["600"],
    purple["600"],
    pink["600"],
    brown["600"],
    grey["600"],
];

export function ManageTagsDialog(props: {
    onClose: () => void;
}) {
    const win = useWindowSize();

    return (
        <Dialog2 open onClose={props.onClose}>
            <DialogTitle>
                Manage Tags
            </DialogTitle>

            <div style={{
                minHeight: win.height * 0.5,
                minWidth: 400,
                display: "flex",
                flexDirection: "column",
                position: "relative"
            }}>
                <PopperZIndexProvider value={1400}>
                    <Table<Tag>
                        name={tableName}
                        cellCustomize={{
                            backgroundColor: (row, col) => {
                                if(col.name === "Color") {
                                    return row.color
                                }

                                return null;
                            },
                        }}
                        columns={[
                            RowOptionCol({
                                options: (dt: ReceivableItem) => [
                                    removeRowOption(dt, {
                                        refreshTables: [tableName],
                                    })
                                ],
                                width: 40,
                            }),
                            StringCol("Name", "name", 100),
                            SelectCol("Color", "color", (input) => {
                                return colors.map(c => ({
                                    // @ts-ignore
                                    display: <TagItem color={c}>{input.props("name").name}</TagItem> as any,
                                    value: c,
                                }))
                            })
                        ]}
                        onChange={(row) => api.tasks2.updateTag(row)}
                        fetch={async (ctx) => getAll(ctx, offset => api.tasks2.listTags({
                            offset,
                        }))}
                        fetchDeps={[]}
                        insert={{
                            alignX: "left",
                            modal(onDone: () => {}): any {
                                return <AutoInsert onDone={onDone} getInput={() => {
                                    return {
                                        name: "",
                                        color: blue["600"],
                                    }
                                }} />
                            }
                        }}
                    />
                </PopperZIndexProvider>
            </div>

            <DialogActions>
                <Button onClick={props.onClose}>Close</Button>
            </DialogActions>
        </Dialog2>
    )
}